<template>
  <v-dialog
    ref="dialog"
    v-model="modal"
    @keydown.esc="cancel"
    width="290px">
    <v-text-field
      slot="activator"
      v-model="localValue"
      label="Expires on" clearable readonly></v-text-field>
    <v-card flat>
      <v-date-picker :min="today" :max="max" v-model="localValue" class="elevation-0" scrollable reactive>
        <v-spacer></v-spacer>
        <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
        <v-btn flat color="primary" @click="save">OK</v-btn>
      </v-date-picker>
      <v-expand-transition>
        <v-alert :value="true" type="warning" v-show="over2months">
          <strong>Distant expiration dates are not recommended</strong>
        </v-alert>
      </v-expand-transition>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'
import Field from '../../mixins/Field'

export default {
  name: 'ExpiryDateField',
  mixins: [Field],
  data () {
    return {
      today: moment().format('YYYY-MM-DD'),
      max: moment().add(9, 'months').format('YYYY-MM-DD'),
      modal: false,
      initialValue: null
    }
  },
  computed: {
    /**
     * Returns true if the selected date is >= 2 months
     *
     * @returns {boolean}
     */
    over2months () {
      return moment(this.localValue, 'YYYY-MM-DD').diff(moment(), 'months') >= 2
    }
  },
  methods: {
    /**
     * Reset the value to the initial one before closing
     */
    cancel () {
      this.localValue = this.initialValue
      this.modal = false
    },
    /**
     * Save the value before closing
     */
    save () {
      this.initialValue = this.localValue
      this.$refs.dialog.save(this.localValue)
    }
  },
  watch: {
    /**
     * Cache the initial value when opening the modal (so we can use reset)
     *
     * @param shown
     */
    modal (shown) {
      if (shown) {
        this.initialValue = this.localValue
      }
    }
  }
}
</script>
